import { ReactNode } from "react";
import { ToastPosition, toast } from "react-toastify";

const baseToaster = (
  message: string | ReactNode,
  type: "success" | "error" | "info" | "warning",
  autoClose: number,
  position: ToastPosition,
) =>
  toast(message, {
    position,
    autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type,
  });

export const successToaster = (
  message: string | ReactNode,
  autoClose = 3000,
  position = "top-right" as ToastPosition,
) => baseToaster(message, "success", autoClose, position);

export const infoToaster = (message: string | ReactNode, autoClose = 3000, position = "top-right" as ToastPosition) =>
  baseToaster(message, "info", autoClose, position);

export const warningToaster = (
  message: string | ReactNode,
  autoClose = 3000,
  position = "top-right" as ToastPosition,
) => baseToaster(message, "warning", autoClose, position);

export const errorToaster = (message: string | ReactNode, autoClose = 3000, position = "top-right" as ToastPosition) =>
  baseToaster(message, "error", autoClose, position);
